import React, { useEffect, useState, useCallback, useRef } from "react";
import styled from "styled-components";
import axios from "axios";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import StepButton from "@mui/material/StepButton";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
// import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@material-ui/core/TableRow";

import { loadStripe } from "@stripe/stripe-js";
import { usePaymentMode } from "../context/PaymentModeContext";

const STRIPE_PK_BY_AFFILIATION = {
  live: {
    UST: "pk_live_51HC8ruLYpiPz9FF4gF6Suk6enWcV7kocqHJdU1jMWm1sck1SlJCrsUftYPDDwWoZ8L6Txo9olw0l6Yv5NAZs2eDJ00KJiF3o00",
    AOSH: "pk_live_51SdXZxH78Av705i4BAPgTkkg1UXpnX0iDCJVjXsv1qzbbDGb7XBZJdPOAFR4Byavg5gCIksVTYHR7VmiiRntYJ0g00UXNHWE14",
  },
  test: {
    UST: "pk_test_51HC8ruLYpiPz9FF416QMwOiY1LJDy6oF3JqZ5YuATtIreOoh6ppEnQk5FQlhFzcpWumBZTefBvznFz595REDm48g00uktcs3u7",
    AOSH: "pk_test_51SdXZxH78Av705i4nWu0dMWDA4sq805vkvrP4pfuI0V3frJp3zCh88WTng5H0gcRTyO3OmE91tHx4ZBrn86Yemo500NXbW2Axs",
  }
};

function getCourseAffiliation(course) {
  const aff = course.affiliation;
  return aff; // "UST" or "AOSH"
}

const steps = ["Guidelines", "Select User(s)", "Select Course(s)"];

const columns = [
  { id: "email", label: "User Email" }, //,minWidth: 170
  { id: "select", label: "Select User(s)" }, //, minWidth: 100
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 150,
    },
  },
};

function CourseRegistrationCompany(props) {
  const [recordProps, setRecordProps] = useState(props.data);
  const [courseStatusSelected, ] = useState("");
  const [userSelectForRegistration, setUserSelectForRegistration] = useState([]);
  const [user,] = useState(JSON.parse(localStorage.getItem("user")));
  const [courseToOrder, setCourseToOrder] = useState(null);
  const [itemsQuantity, setItemsQuantity] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [, setCompleted] = useState({});

  // New from Davis
  const [enrollmentScope, setEnrollmentScope] = useState("needs");
  const [newOwnedCourseUsers, setNewOwnedCourseUsers] = useState(() => new Set());
  const [alreadyCertifiedUsers, setAlreadyCertifiedUsers] = useState(() => new Set());
  const [notAssignedUsers, setNotAssignedUsers] = useState(() => new Set());
  const [expiredUsers, setExpiredUsers] = useState(() => new Set());

  const { mode } = usePaymentMode();


  // ========================================================
  const summaryRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const el = summaryRef.current;
    if (!el) return;

    let rafId = null;

    const checkOverflow = () => {
      if (!el) return;

      // measure
      const next = el.scrollHeight > el.clientHeight;

      // schedule state update after layout settles
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        setIsScrollable(prev => (prev === next ? prev : next));
      });
    };

    // run once
    checkOverflow();

    const ro = new ResizeObserver(checkOverflow);
    ro.observe(el);

    return () => {
      cancelAnimationFrame(rafId);
      ro.disconnect();
    };
  }, [newOwnedCourseUsers, alreadyCertifiedUsers, expiredUsers, notAssignedUsers]);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [mainRecordProps, setMainRecordProps] = useState(null);
  const [searchedRecords, setSearchedRecords] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // ==========================================================

  const totalSteps = () => {
    return steps.length;
  };

  const isStepCompleted = (step) => {
    if (step === 0) return true;

    if (step === 1) {
      return userSelectForRegistration.length > 0;
    }

    if (step === 2) {
      return !!courseToOrder;
    }

    return false;
  };

  const handleNext = () => {
    if (activeStep === 1 && userSelectForRegistration.length === 0) {
      return;
    }

    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
  if (activeStep === 1) {
    setUserSelectForRegistration([]);
    setItemsQuantity(0);
    setRecordProps(prev => {
      const arr = Array.isArray(prev) ? [...prev] : [];
      arr.forEach(r => { r.isChecked = false; });
      return arr;
    });
  } else if (activeStep === 2) {
    setCourseToOrder("")
    setEnrollmentScope("needs")
    setNewOwnedCourseUsers([]);
    setAlreadyCertifiedUsers([]);
    setExpiredUsers([]);
    setNotAssignedUsers([]);    
  }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    // Always allow Guidelines
    if (step === 0) {
      setActiveStep(0);
      return;
    }

    // Always allow Select Users
    if (step === 1) {
      setActiveStep(1);
      return;
    }

    // Only allow Select Courses if a user has been selected
    if (step === 2 && userSelectForRegistration.length > 0) {
      setActiveStep(2);
    }
  };

  // Display email items
  const [expandedSections, setExpandedSections] = useState({
    valid: false,
    renewal: false,
    expired: false,
    noHistory: false,
  });

  function toggleSection(key) {
    setExpandedSections(prev => ({ ...prev, [key]: !prev[key] }));
  }

  // Identify the need of the course based on those selected
  const handleChange = async (event) => {
    setNewOwnedCourseUsers([])
    setAlreadyCertifiedUsers([])
    setNotAssignedUsers([])
    setExpiredUsers([])
    setEnrollmentScope("needs") 

    const course = event.target.value;
    if (course) setCourseToOrder(course);

    const userEmails = userSelectForRegistration
      .map(u => String(u.userEmail || "").trim().toLowerCase())
      .filter(Boolean);

    const res = await axios.post("/courseStatusBulk", { courseId: course.id, userEmails, });
    
    // Priority 1. Identify individuals where no course data exists
    const rows = res.data.rows ?? [];
    const filterSet = new Set(rows.map(r => String(r.userEmail || "").toLowerCase()));
    const notPreviouslyAssigned = userEmails.filter(email => !filterSet.has(email));
    setNotAssignedUsers(notPreviouslyAssigned);

    // Priority 2. Identify those who already own a new course; filter email out if expired or certified course(s) also exists
    const ownUncertifiedCourse = rows
      .filter(item => !item.certifiedAt)
      .map(item => String(item.userEmail || "").toLowerCase());
    setNewOwnedCourseUsers(ownUncertifiedCourse)
    ownUncertifiedCourse.forEach(email => {filterSet.delete(email)})

    // Priority 3. User only owns Valid courses; filter email out if an expired course also exists
    const currentDate = new Date();

    const ownCertifiedCourse = rows
      .filter(item =>
        item.expiresOn &&
        new Date(item.expiresOn) > currentDate &&
        filterSet.has(String(item.userEmail || "").toLowerCase()))
      .map(item => String(item.userEmail || "").toLowerCase());
    setAlreadyCertifiedUsers(ownCertifiedCourse);
    ownCertifiedCourse.forEach(email => filterSet.delete(email));

    // Priority 4. User only owns expired Course
    const ownExpiredCourse = rows
      .filter(item =>
        item.expiresOn &&
        new Date(item.expiresOn) <= currentDate &&
        filterSet.has(String(item.userEmail || "").toLowerCase()))
      .map(item => String(item.userEmail || "").toLowerCase());
    setExpiredUsers(ownExpiredCourse);
  };

  const onChangeEmailSearch = (e) => {
    if (recordProps) {
      let searchKey = e.target.value;
      let tempAllArr = [...mainRecordProps];
      if ( courseStatusSelected.trim() === "" || courseStatusSelected === "all" ) {
        if (searchKey.trim() === "") {
          setSearchedRecords(tempAllArr);
        } else {
          var filtered = tempAllArr.filter(function (value, index, arr) {
            return (
              value.userEmail.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
            );
          });
          setSearchedRecords(filtered);
        }
      } else {
        filtered = tempAllArr.filter(function (value, index, arr) {
          return (
            value.role === courseStatusSelected &&
            value.userEmail.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
          );
        });
        setSearchedRecords(filtered);
      }
    }
  };

  const onChangeUserSelect = (e, userEmail, key) => {
    if (e.target.checked) {
      setUserSelectForRegistration([
        ...userSelectForRegistration,
        { userEmail: userEmail, type: "Team" },
      ]);
      let tempArr = [...recordProps];
      tempArr[key].isChecked = true;
      setRecordProps(tempArr);
      setItemsQuantity(itemsQuantity + 1);
    } else {
      let tempArr = [...userSelectForRegistration];
      let findIndx = tempArr?.map((item) => item.userEmail)?.indexOf(userEmail) ?? -1;
      if (findIndx >= 0) {
        tempArr.splice(findIndx, 1);
        setUserSelectForRegistration(tempArr);
      }

      let tempSecArr = [...recordProps];
      tempSecArr[key].isChecked = false;
      setRecordProps(tempSecArr);
      setItemsQuantity(itemsQuantity - 1);
    }
  };


  //     // decide which list of emails you are purchasing for (needs a new course or all)
  //     const submittedUserList = enrollmentScope === "needs" 
  //       ? [...expiredUsers, ...notAssignedUsers]
  //       : [...expiredUsers, ...notAssignedUsers, ...alreadyCertifiedUsers]

  //     // convert to old format {userEmail: 'email@email.com', type: 'Team'}
  //     const formattedUsers = submittedUserList.map(email => ({
  //       userEmail: email,
  //       type: "Team",
  //     }));
      
  //     // submit information for checkout
  //     stripePayment(formattedUsers);
  //   }
  // };


  const onClickSaveToCartProcess = () => {
    // if there is 1. a user logged in 2. a course selected and 3. more than 1 person to purchase for
    if ( user && userSelectForRegistration.length > 0 && courseToOrder ) {
      // decide which list of emails you are purchasing for (needs a new course or all)
      const submittedUserList = enrollmentScope === "needs" 
        ? [...expiredUsers, ...notAssignedUsers]
        : [...expiredUsers, ...notAssignedUsers, ...alreadyCertifiedUsers]
      // convert to old format {userEmail: 'email@email.com', type: 'Team'}
      const formattedUsers = submittedUserList.map(email => ({
        userEmail: email,
        type: "Team",
      }));

      if(formattedUsers) {
        axios
          .post("/addToTeamCart", {
            teamId: recordProps[0].teamId,
            userId: user.UserID,
            courseId: courseToOrder.id,
            coursePrice: courseToOrder.price,
            courseName: courseToOrder.name,
            usersTookCourse: [],
            usersNotTookCourse: formattedUsers,
          })
          .then(() => {
            setCourseToOrder(null);
            setRecordProps([...recordProps]);
            setUserSelectForRegistration([]);
            setActiveStep(0);
            setCompleted({});
            props.onClickResetItemNumber(props.teamIdProp);
          });
        }

    }
  };

  
  const onClickCheckOutProcess = async () => {
    // if there is 1. a user logged in 2. a course selected and 3. more than 1 person to purchase for
    if ( user && courseToOrder && userSelectForRegistration.length > 0 ) {
      // decide which list of emails you are purchasing for (needs a new course or all)
      const submittedUserList = enrollmentScope === "needs" 
        ? [...expiredUsers, ...notAssignedUsers]
        : [...expiredUsers, ...notAssignedUsers, ...alreadyCertifiedUsers]

      // convert to old format {userEmail: 'email@email.com', type: 'Team'}
      const formattedUsers = submittedUserList.map(email => ({
        userEmail: email,
        type: "Team",
      }));
      
      // submit information for checkout
      stripePayment(formattedUsers);
    }
  };

  const allFilteredRows = (searchedRecords || []).filter(
    (r) => !r?.displayEmail && !r?.displayCourse && !r?.displayStatus
  );

  const allFilteredEmails = allFilteredRows.map((r) => r.userEmail);

  const selectedFilteredCount = allFilteredRows.filter((r) => r.isChecked).length;
  const allFilteredSelected = allFilteredRows.length > 0 && selectedFilteredCount === allFilteredRows.length;
  const someFilteredSelected = selectedFilteredCount > 0 && selectedFilteredCount < allFilteredRows.length;

  const onToggleSelectAllFiltered = (checked) => {
    const emailSet = new Set(allFilteredEmails);

    // 1) mark isChecked on ALL filtered rows (not just page)
    setRecordProps((prev) => {
      const arr = Array.isArray(prev) ? [...prev] : [];
      arr.forEach((r) => {
        if (emailSet.has(r.userEmail)) r.isChecked = checked;
      });
      return arr;
    });

    // 2) update selected users list
    setUserSelectForRegistration((prev) => {
      const map = new Map((prev || []).map((u) => [u.userEmail, u]));

      if (checked) {
        allFilteredEmails.forEach((email) => {
          if (!map.has(email)) map.set(email, { userEmail: email, type: "Team" });
        });
      } else {
        allFilteredEmails.forEach((email) => map.delete(email));
      }

      return Array.from(map.values());
    });

    // 3) keep quantity in sync
    setItemsQuantity((prev) => {
      const toAdd = allFilteredRows.filter((r) => !r.isChecked).length;
      const toRemove = allFilteredRows.filter((r) => r.isChecked).length;
      return checked ? prev + toAdd : Math.max(0, prev - toRemove);
    });
  };




  const stripePayment = useCallback(async (usersForPurchase) => {
    if (usersForPurchase?.length > 0) {
      const finalItemsQuantity = usersForPurchase.length;

      const affiliation = getCourseAffiliation(courseToOrder);
      if (!affiliation || affiliation === "MIXED") {
        alert("No affilaition recorded for course")
        return;
      }

      const publishableKey = STRIPE_PK_BY_AFFILIATION[mode]?.[affiliation];
      if (!publishableKey) {
        alert(`Unknown affiliation: ${mode}/${affiliation}`);
        return;
      }

      const stripe = await loadStripe(publishableKey);      
      const stripeSession = await axios.post("/create-checkout-session", {
        customerID: user.UserID,
        items: [courseToOrder],
        email: user.email,
        users: usersForPurchase,
        quantity: finalItemsQuantity,
        teamId: recordProps[0].teamId,
        requestedMode: mode,
      });

      const result = await stripe.redirectToCheckout({
        sessionId: stripeSession.data.id,
      });

      if (result.error) {
        alert(result.error.message);
      }
    }
  }, [user, courseToOrder, recordProps, mode]);

  // ====================functions============================

  const userTable = (
    <div style={{ margin: "30px 0px 20px 0px" }}>
      <CustomTable>
        <SearchTable>
          <EmailSearchContainer>
            <EmailSearch
              onChange={(e) => onChangeEmailSearch(e)}
              placeholder="Email..."
            />
            <EmailSearchButton>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-search"
                viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
              </svg>
            </EmailSearchButton>
          </EmailSearchContainer>
        </SearchTable>
        {/* ===========main pagination table======= */}
        <Paper sx={{ width: "100%", overflow: "hidden"}}>
          <TableContainer sx={{ height: "350px" }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth, fontWeight: "bold" }}
                    >
                      {column.id === "select" ? (
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <input
                            type="checkbox"
                            checked={allFilteredSelected}
                            ref={(el) => {
                              if (el) el.indeterminate = someFilteredSelected;
                            }}
                            onChange={(e) => onToggleSelectAllFiltered(e.target.checked)}
                          />
                          {column.label}
                        </div>
                      ) : (
                        column.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {(searchedRecords ?? [])
                    .sort((a,b) => a.userEmail.localeCompare(b.userEmail))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                        <TableRow 
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                          style={{
                            display:
                              !row?.displayEmail && !row?.displayCourse &&  !row?.displayStatus
                                ? "" : "none",
                          }}>
                          <TableCell>{row.userEmail}</TableCell>
                          <TableCell>
                            <SelectCompanyUser
                              type="checkbox"
                              onChange={(e) => onChangeUserSelect(e, row.userEmail, row.id)}
                              checked={!!row?.isChecked}
                            />
                          </TableCell>
                        </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={ searchedRecords?.length || 0 }
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </CustomTable>
    </div>
  );

  const guideLines = (
    <div style={{ margin: "30px 0px 20px 0px" }}>
      <p>
        - You can select user(s) in the second step to register a course for
        them. The course can be selected in the third step.
      </p>
      <p>
        - If user(s) have already took course(s), they will only recieve a note
        to share their course status with your team and you will not be charged
        for the course(s).
      </p>
    </div>
  );

  const courseSelect = (
    <SelectUserCourse>
      <FormControl className="course-select">
        <InputLabel id="demo-multiple-name-label">Course</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          // multiple
          value={courseToOrder || ""}
          onChange={(e) => handleChange(e)}
          input={<OutlinedInput label="Course" />}
          MenuProps={MenuProps}>
          {(props.courseInformation ?? [])
            .slice()
            .sort((a,b) => (a?.name ?? "").localeCompare(b?.name ?? ""))
            .map((courseItems, key) => (
              <MenuItem value={courseItems} key={key + 1}>
                {courseItems?.name ?? ""}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      {courseToOrder?.id && 
      (newOwnedCourseUsers?.length !== 0 || 
       alreadyCertifiedUsers?.length !== 0 || 
       expiredUsers?.length !== 0 ||
       notAssignedUsers?.length !== 0
      ) && (
        <UserEnrollmentSummary ref={summaryRef} $scroll={isScrollable}>
          <UserInformation>
            <UserInformationHeader onClick={() => toggleSection("valid")}>
              <span>
                <strong>Valid Existing Enrollment</strong> - PURCHASE UNAVAILABLE & UNNECESSARY - (Users: {newOwnedCourseUsers?.length})
              </span>
              <span>{expandedSections.valid ? "▾" : "▸"}</span>
            </UserInformationHeader>

            {expandedSections.valid && (
              <EmailList>
                {(newOwnedCourseUsers ?? []).map(email => (
                  <EmailItem key={email}>{email}</EmailItem>
                ))}
              </EmailList>
            )}
          </UserInformation>

          <UserInformation>
            <UserInformationHeader onClick={() => toggleSection("renewal")}>
              <span>
                <strong>Early Certification Renewal</strong> - optional - (Users: {alreadyCertifiedUsers?.length})
              </span>
              <span>{expandedSections.renewal ? "▾" : "▸"}</span>
            </UserInformationHeader>

            {expandedSections.renewal && (
              <EmailList>
                {(alreadyCertifiedUsers ?? []).map(email => (
                  <EmailItem key={email}>{email}</EmailItem>
                ))}
              </EmailList>
            )}
          </UserInformation>

          <UserInformation>
            <UserInformationHeader onClick={() => toggleSection("expired")}>
              <span>
                <strong>Expired &amp; Needs Renewal</strong> (Users: {expiredUsers?.length})
              </span>
              <span>{expandedSections.expired ? "▾" : "▸"}</span>
            </UserInformationHeader>

            {expandedSections.expired && (
              <EmailList>
                {(expiredUsers ?? []).map(email => (
                  <EmailItem key={email}>{email}</EmailItem>
                ))}
              </EmailList>
            )}
          </UserInformation>

          <UserInformation>
            <UserInformationHeader onClick={() => toggleSection("noHistory")}>
              <span>
                <strong>No Assignment History</strong> (Users: {notAssignedUsers?.length})
              </span>
              <span>{expandedSections.noHistory ? "▾" : "▸"}</span>
            </UserInformationHeader>

            {expandedSections.noHistory && (
              <EmailList>
                {(notAssignedUsers ?? []).map(email => (
                  <EmailItem key={email}>{email}</EmailItem>
                ))}
              </EmailList>
            )}
          </UserInformation>
          {(alreadyCertifiedUsers?.length > 0) && (expiredUsers?.length+notAssignedUsers?.length !== expiredUsers?.length+notAssignedUsers?.length+alreadyCertifiedUsers?.length) &&
            <EnrollmentCard>
              <EnrollmentSummary>
                <strong style={{fontSize:"18px"}}>Who do you wish to enroll? </strong>
                You are about to purchase{" "}
                <strong>
                  {enrollmentScope === "needs" 
                    ? (expiredUsers?.length+notAssignedUsers?.length) 
                    : (expiredUsers?.length+notAssignedUsers?.length+alreadyCertifiedUsers?.length)}
                </strong>{" "}
                enrollments.
              </EnrollmentSummary>

              <RadioOption
                $active={enrollmentScope === "needs"}
                onClick={() => setEnrollmentScope("needs")}
              >
                <input
                  type="radio"
                  name="enrollmentScope"
                  checked={enrollmentScope === "needs"}
                  onChange={() => setEnrollmentScope("needs")}
                />
                <div>
                  <RadioLabel>
                    Only Users Who Need Certification ({expiredUsers?.length+notAssignedUsers?.length} users)
                  </RadioLabel>
                  <RadioSubText>
                    Includes expired and not certified users.
                  </RadioSubText>
                </div>
              </RadioOption>

              <RadioOption
                $active={enrollmentScope === "all"}
                onClick={() => setEnrollmentScope("all")}
              >
                <input
                  type="radio"
                  name="enrollmentScope"
                  checked={enrollmentScope === "all"}
                  onChange={() => setEnrollmentScope("all")}
                />
                <div>
                  <RadioLabel>
                    All Available Users ({expiredUsers?.length+notAssignedUsers?.length+alreadyCertifiedUsers?.length} users)
                  </RadioLabel>
                  <RadioSubText>
                    Includes expired, not certified, and certified users in need of renewal
                  </RadioSubText>
                </div>
              </RadioOption>
            </EnrollmentCard>
          }
        </UserEnrollmentSummary>)
      }
    </SelectUserCourse>
  );

  const stepsContent = [guideLines, userTable, courseSelect];

  useEffect(() => {
    if (props.data) {
      setRecordProps(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    if (recordProps) {
      let tempArr = [...recordProps];
      tempArr.forEach((item, key) => {
        item.id = key;
      });
      setMainRecordProps(tempArr);
    }
    return () => {
      setMainRecordProps(null);
    };
  }, [recordProps]);

  useEffect(() => {
    return () => {
      setMainRecordProps(null);
      setRecordProps(null);
    };
  }, []);

  useEffect(() => {
    if (mainRecordProps) {
      setSearchedRecords(mainRecordProps);
    }
  }, [mainRecordProps]);

  return (
    <Container>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        <Stepper nonLinear activeStep={activeStep}>
          {steps.map((label, index) => (
            <Step key={label} completed={isStepCompleted(index)}>
              <StepButton color="inherit" onClick={handleStep(index)}>
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>

        <StepContent>
          {stepsContent[activeStep]}
        </StepContent>

        <BottomControls>
          <Button
            color="inherit"
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            Back
          </Button>

          {activeStep !== totalSteps() - 1 && (
            <Button
              onClick={handleNext}
              sx={{ mr: 1 }}
              disabled={
                activeStep === 1 &&
                userSelectForRegistration.length === 0
              }
            >
              Next
            </Button>
          )}

          {activeStep === 2 && courseToOrder && (
            <EndOfProcessButtons>
              <Button
                onClick={onClickSaveToCartProcess}
                sx={{ mr: 1 }}
              >
                <strong>Save to cart</strong>
              </Button>

              <Button onClick={onClickCheckOutProcess}>
                <strong>Check Out</strong>&nbsp;
                {enrollmentScope === "needs"
                  ? `(${expiredUsers.length + notAssignedUsers.length})`
                  : `(${expiredUsers.length +
                      notAssignedUsers.length +
                      alreadyCertifiedUsers.length})`}
              </Button>
            </EndOfProcessButtons>
          )}
        </BottomControls>
      </Box>
    </Container>
  );
}

export default CourseRegistrationCompany;

const EndOfProcessButtons = styled.div`
  display: flex;
  align-items: center;
`;

const Container = styled.div`
  padding: 20px;
  height: 725px;
`;
const StepContent = styled.div`
  position: absolute;
  top: 60px;
  bottom: 55px;
  left: 0;
  right: 0;

  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;
const BottomControls = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;

  height: 55px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  z-index: 10;
`;

const CustomTable = styled.div`
  width: 100%;
`;
const SearchTable = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 10px;
`;

const SelectUserCourse = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .course-select {
    width: 100% !important;
    margin: 30px 0px 20px 0px !important;
    flex-shrink: 0;
  }
`;

const UserEnrollmentSummary = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  border: ${props => props.$scroll ? "2px solid #00000030" : "none"};
  padding: ${props => props.$scroll ? "0 8px 0 5px" : "0"};
  border-radius: ${props => props.$scroll ? "6px 0 0 6px" : "0"};
`;

const UserInformation = styled.div`
  border: 1px solid #00000030;  
  background: #f6f6f6;
  border-radius: 6px;
  margin: 10px 0;
`;

const UserInformationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  font-size: 14px;
  cursor: pointer;
`;

const EmailList = styled.div`
  overflow-y: auto;
  padding: 8px 12px 12px;
  border-top: 1px solid #00000020;
  column-width: 200px;     /* tweak */
  column-gap: 18px;

  width: 100%;
`;

const EmailItem = styled.div`
  break-inside: avoid;
  padding: 3px 0;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const EnrollmentCard = styled.div`
  border: 1px solid #00000020;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
  background: #f8f8f8;
`;

const RadioOption = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid
    ${props => (props.$active ? "rgba(95,176,95,0.6)" : "#00000015")};
  background: ${props =>
    props.$active ? "rgba(95,176,95,0.08)" : "white"};

  input {
    margin-top: 4px;
  }

  &:hover {
    background: rgba(95,176,95,0.05);
  }
`;

const RadioLabel = styled.div`
  font-weight: 600;
  font-size: 15px;
`;

const RadioSubText = styled.div`
  font-size: 13px;
  color: #666;
`;

const EnrollmentSummary = styled.div`
  margin-bottom: 15px;
  font-size: 14px;
  text-align: center;
`;

const SearchContainers = [
  `
    position:relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:5px;
  `,
];

const EmailSearchContainer = styled.div(SearchContainers);

const SearchBoxes = [
  `
    width: 100%;
    padding: 7px 7px 7px 28px;

    option{
        // padding:7px 0px 7px 0px;
        // height:20px;
    }
  `,
];

const SearchButtons = [`
  position:absolute;
  border:none;
  outline:none;
  left:15px;
  background-color: transparent;
  // cursor:pointer;
  svg{ fill:rgba(0,0,0,0.5)}`,];

const EmailSearch = styled.input(SearchBoxes);
const EmailSearchButton = styled.button(SearchButtons);

const SelectCompanyUser = styled.input``;

